import React, { useState, useEffect } from 'react';
import { FaHtml5 } from "react-icons/fa";
import { FaCss3Alt } from "react-icons/fa";
import { TbBrandJavascript } from "react-icons/tb";
import { RiReactjsFill } from "react-icons/ri";
import { FaJava } from "react-icons/fa";
import './cheatsheets.scss';

const Cheatsheets = () => {
    const [cheatsheets, setCheatsheets] = useState([]);
    const [error, setError] = useState(null);
    const iconMap = {
        HTML: <FaHtml5 className='IconName' />,
        CSS: <FaCss3Alt className='IconName' />,
        JavaScript: <TbBrandJavascript className='IconName' />,
        "React Js": <RiReactjsFill className='IconName' />,
        Java: <FaJava className='IconName' />
    };

    const getAllPDF = async () => {
        try {
            const resp = await fetch('/data/db.json');
            if (!resp.ok) {
                throw new Error(`HTTP error! Status: ${resp.status}`);
            }
            const data = await resp.json();
            setCheatsheets(data.CheatsheetsData);
        } catch (err) {
            setError(`Error fetching data: ${err.message}`);
        }
    };

    useEffect(() => {
        getAllPDF();
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="mainCheatsheet">
            <div className="subCheatsheet">
                {cheatsheets.length > 0 ? (
                    cheatsheets.map((item) => (
                        <div key={item.id} className="Cheatsheet">
                            <div className="mainCheatsheet-border-top"></div>
                            <div className="img">
                                {iconMap[item.name] || "📄"}
                            </div>
                            <span>{item.title}</span> {/* Dynamic Title */}
                            <p className="job">{item.description}</p> {/* Dynamic Description */}
                            <a href={item.CheatSheetDownload} target="_blank" rel="noopener noreferrer" download>
                                <button>Download PDF</button> {/* Dynamic PDF Download */}
                            </a>
                        </div>
                    ))
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </div>
    );
};

export default Cheatsheets;